import { FC } from "react";
import { CellClassParams } from "ag-grid-community";
import { AzureUtilizationAndCoverageDataViewTabs } from "./components/AzureUtilizationAndCoverageDataViewTabs";
import { azureSavingsPlansTableColumnDefs } from "./columns/azureSavingsPlansTableColumnDefs";
import { CommitmentsAGGridToolbar } from "../../../../../common/components/data-grid/toolbar/CommitmentsAGGridToolbar";
import {
  CommitmentsAgGrid,
  CommitmentsToolbar,
} from "../../../../../common/components/CommitmentsAgGrid";
import { useAppSelector } from "@/store/hooks";
import { azureSavingsPlansDataSelector } from "@/store/commitments/selectors/azure/coverage-and-utilization/data/azureSavingsPlansDataSelector";
import { azureSavingsPlansForTableLoadingSelector } from "@/store/commitments/selectors/azure/coverage-and-utilization/data/loading/azureSavingsPlansForTableLoadingSelector";
import { AzureSavingsPlan } from "@/services/cloudchipr.api";
import { CommitmentsDetailsRequestData } from "@/store/commitments/utils/types/types";

export const AzureSavingsPlansDataGrid: FC = () => {
  const data = useAppSelector(azureSavingsPlansDataSelector);
  const loading = useAppSelector(azureSavingsPlansForTableLoadingSelector);

  return (
    <CommitmentsAgGrid
      data={data}
      Toolbar={toolbar}
      loading={loading}
      grouping="commitment"
      columnDefs={azureSavingsPlansTableColumnDefs}
      overrideDefaultColDef={overrideDefaultColDef}
      clickHandlerDataGetter={clickHandlerDataGetter}
      localStorageUniqueKey="azureSavingsPlanDataGrid"
    />
  );
};

const clickHandlerDataGetter = (
  data: AzureSavingsPlan,
): CommitmentsDetailsRequestData => ({
  targetType: "commitment",
  targetId: data?.provider_unique_id,
  commitmentId: data?.id,
});

const overrideDefaultColDef = {
  cellStyle: (cell: CellClassParams<AzureSavingsPlan>) => ({
    backgroundColor:
      cell?.data?.state === "expires_soon" ? "#ed6c0216" : "inherit",
  }),
};

const toolbar: CommitmentsToolbar = ({ gridApi }) => (
  <CommitmentsAGGridToolbar provider="azure" gridApi={gridApi}>
    <AzureUtilizationAndCoverageDataViewTabs />
  </CommitmentsAGGridToolbar>
);
